<div class="flex items-center justify-center dialog-header ">
    Delete Pakcage

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>


<div class="dialog-content">

    <div class="text-center p-4">
        <p>Are you sure you want to delete this package?</p>
        <p class="text-red-500 font-bold">This action cannot be undone.</p>
    </div>

    <div class="flex justify-center p-4 space-x-2">
        <button pButton label="Delete"
        severity="danger"
        [loading]="loading"
        icon="pi pi-check" (click)="deletePackage()" class="p-button-sm"></button>
    </div>
</div>